export default [
  {
    type: 'input',
    placeholder: '类型名称',
    filed: 'name',
    default: ''
  }
]
